module.exports = __webpack_public_path__ + "6790e8c5.woff";